import UpdateUser from "./UpdateUser";

export default UpdateUser;